import React from 'react';
import { Stack, Typography } from '@mui/material';

type TTabLabelProps = {
  icon: React.ReactNode;
  label: string;
};

export const TabLabel: React.FC<TTabLabelProps> = ({ icon, label }: TTabLabelProps) => {
  return (
    <Stack direction="row" gap={1} alignItems="center">
      {icon}
      <Typography>{label}</Typography>
    </Stack>
  );
};
